import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { errMsg, eur, fmtDate, num, useApi } from "@/lib/api";
import { StateBadge } from "@/components/club/StatusBadge";
import { Btn, Table, Td } from "./AdminUi";

const NEXT = {
  fatelo_voi: [["pagato", "Pagato"], ["acquistato", "Acquistato"], ["spedito", "Spedito"], ["consegnato", "Consegnato"]],
  status: [["pagato", "Pagato (status attivo)"]],
  marketplace: [["pagato", "Pagato"], ["in_preparazione", "In preparazione"], ["spedito", "Spedito"], ["pronto_ritiro", "Pronto per il ritiro"], ["consegnato", "Consegnato"]],
};

const addr = (o) => (o.type === "status" ? "" : o.delivery === "pickup" ? "Ritiro in sede" : o.address ? `${o.address.full_name}, ${o.address.street}, ${o.address.zip} ${o.address.city} ${o.address.province}` : "—");

export function AdminOrders({ mode }) {
  const api = useApi();
  const [rows, setRows] = useState([]);
  const load = useCallback(async () => {
    const params = mode === "bonifici" ? { status: "in_attesa_bonifico" } : { type: mode };
    setRows(await api("get", "/admin/orders", null, params));
  }, [api, mode]);
  useEffect(() => { load().catch(() => {}); }, [load]);

  const act = async (fn, msg) => {
    try {
      await fn();
      toast.success(msg);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Table testid={`admin-orders-${mode}`} empty={!rows.length} head={["Ordine", "Cliente", "Prodotti", "Importi", "Stato", "Azioni"]}>
      {rows.map((o) => (
        <tr key={o.id} data-testid={`admin-order-${o.id}`}>
          <Td><p className="font-mono text-white">{o.causale}</p><p className="text-xs text-slate-500">{o.type === "fatelo_voi" ? "Fatelo voi" : o.type === "status" ? `Status ${o.status_level}` : `Marketplace · ${o.partner_name}`}</p><p className="text-xs text-slate-500">{fmtDate(o.created_at)}</p></Td>
          <Td><p className="text-white">{o.customer_name}</p><p className="text-xs text-slate-500">{o.customer_email} · {o.phone}</p><p className="text-xs text-slate-500">{addr(o)}</p></Td>
          <Td>{o.items.map((i, k) => <p key={k} className="text-slate-300">{i.qty} × {i.name}{i.shop ? ` (${i.shop})` : ""} {i.url && <a href={i.url} target="_blank" rel="noreferrer" className="text-amber-400">↗</a>}</p>)}</Td>
          <Td className="whitespace-nowrap"><p>Totale {eur(o.total)}</p>{o.points_used > 0 && <p className="text-xs text-amber-300">−{num(o.points_used)} pt ({eur(o.points_discount)})</p>}<p className="font-semibold text-white">Bonifico {eur(o.amount_due)}</p></Td>
          <Td><StateBadge status={o.status} testid={`admin-order-status-${o.id}`} />{o.points_awarded > 0 && <p className="mt-1 text-xs text-amber-300">+{num(o.points_awarded)} pt</p>}</Td>
          <Td>
            <div className="flex flex-col gap-2">
              {o.status === "in_attesa_bonifico" && <Btn variant="ok" testid={`confirm-payment-${o.id}`} onClick={() => act(() => api("post", `/admin/orders/${o.id}/confirm-payment`), "Bonifico confermato, punti accreditati")}>Bonifico ricevuto</Btn>}
              {o.status !== "in_attesa_bonifico" && o.status !== "annullato" && (
                <Select value={o.status} onValueChange={(v) => act(() => api("post", `/admin/orders/${o.id}/status`, { status: v }), "Stato aggiornato")}>
                  <SelectTrigger data-testid={`order-status-select-${o.id}`} className="h-8 w-40 bg-[#1C1F2C] text-xs"><SelectValue /></SelectTrigger>
                  <SelectContent>{NEXT[o.type].map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
                </Select>
              )}
              {o.status !== "annullato" && <Btn variant="warn" testid={`cancel-order-${o.id}`} onClick={() => window.confirm(`Annullare l'ordine ${o.causale}? Punti e stock verranno ripristinati.`) && act(() => api("post", `/admin/orders/${o.id}/cancel`), "Ordine annullato")}>Annulla</Btn>}
            </div>
          </Td>
        </tr>
      ))}
    </Table>
  );
}
